import React from 'react';
import { useEffect, useState } from 'react';
import { birthdayData, props } from '../../App';
import { defaultImage, urlImage, urlList } from '../../components/URLlist/urlList';

import './home.css';
import Header from '../../components/header/header';
import { saveConsoleLog } from '../../helpFunction/helpFunction';
import Edit from '../../components/edit/edit';

export type sortProps = 'Pozostało' | 'A-Z' | string;

const Home = ({ setMassage, setViews, setSpinner }: props) => {
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState<birthdayData[] | []>([]);
  const [edit, setEdit] = useState<{ visible: boolean; id: string }>({ visible: false, id: '' });
  const [sort, setSort] = useState<sortProps>('Pozostało');
  const [search, setSearch] = useState<string | ''>('');

  let base: birthdayData[] = [];

  useEffect(() => {
    loadData();
  }, [refresh]);

  const loadData = () => {
    setSpinner(true);

    fetch(urlList, { credentials: 'include' })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          setViews({ login: true });
          return;
        }
      })
      .then((res) => {
        setData(res);
      })
      .catch((err) => {
        setViews({ login: true });
        saveConsoleLog(`APKA error z Home get list, ${err}`);
      })
      .finally(() => {
        setSpinner(false);
      });
  };

  const pozostalo = (date: string): number => {
    if (date === undefined) {
      return 0;
    }

    const month = date[5] + date[6];
    const day = date[8] + date[9];

    let thisYear = Number(new Date().toISOString().split('-')[0]);
    let today = new Date();
    let todayYear = new Date().toISOString().split('-')[0];

    today.setHours(0, 0, 0, 0);

    let bday = new Date(`${thisYear}-${month}-${day}`);
    bday.setHours(0, 0, 0, 0);

    let upcomingBday = new Date(`${todayYear}-${month}-${day}`);
    upcomingBday.setHours(0, 0, 0, 0);

    if (today > upcomingBday) {
      upcomingBday.setFullYear(Number(todayYear) + 1);
    }

    const one_day = 24 * 60 * 60 * 1000;

    let daysLeft = Math.ceil((upcomingBday.getTime() - today.getTime()) / one_day);

    return daysLeft === 365 ? 0 : daysLeft;
  };

  const modifyList = async () => {
    data.map((e: birthdayData) => {
      base.push({
        nazwisko: e.nazwisko,
        imie: e.imie,
        data_ur: e.data_ur,
        id: e.id,
        userID: e.userID,
        last: pozostalo(e.data_ur),
        dataLast: new Date(),
        image: e.image,
      });
      return null;
    });
  };

  modifyList();

  function sortBaza() {
    if (sort === 'Pozostało') {
      base.sort(function (a: birthdayData, b: birthdayData) {
        let x = a.last;
        let y = b.last;
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }
    if (sort === 'A-Z') {
      base.sort((a: birthdayData, b: birthdayData) => {
        let x = a.nazwisko;
        let y = b.nazwisko;
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }
    if (search) {
      // eslint-disable-next-line array-callback-return
      base = base.filter((item) => {
        const data = item.nazwisko.toLocaleUpperCase() + item.imie.toLocaleUpperCase();
        if (data.includes(search.toLocaleUpperCase())) return item;
      });
    }
    return base;
  }

  const wiek = (data: string) => {
    return Math.floor((Number(new Date()) - Number(new Date(data))) / 1000 / 60 / 60 / 24 / 365.242199);
  };

  const onClick = async (e: any) => {
    setEdit({ visible: true, id: e });
  };

  return (
    <>
      <div className='homeContainer'>
        <Header setRefresh={setRefresh} refresh={refresh} setMassage={setMassage} setSpinner={setSpinner} setSort={setSort} setSearch={setSearch} search={search} />
        <div className='line'></div>

        {edit.visible && <Edit id={edit.id} refresh={refresh} setRefresh={setRefresh} setMassage={setMassage} setEdit={setEdit} setSpinner={setSpinner} />}
        <div className='homeList'>
          {sortBaza().map((item) => {
            return (
              <div className={'viewItem'} style={pozostalo(item.data_ur) < 10 ? { backgroundColor: 'rgba(0, 255, 0, 0.5)' } : {}} onClick={() => onClick(item.id)} key={item.id} onSelect={() => console.log('hh')}>
                <div className='imageView'>
                  <img className='imageHome' alt='zdjecie' srcSet={item.image ? `${urlImage}${item.userID}/${item.image}` : defaultImage} />
                </div>
                <div className={'homeName'}>
                  <p className='homeText'>
                    {item.nazwisko} {item.imie}
                  </p>

                  <p className={'homeText'}>ur.{item.data_ur}</p>
                  <p className={'homeText'}>lat.{wiek(item.data_ur)}</p>
                </div>
                <div className={'homePozostalo'}>
                  <p className={'homeText'}> {pozostalo(item.data_ur) === 0 ? 'Dzisiaj' : 'Pozostało'}</p>
                  <p className={'homeText'}>
                    {pozostalo(item.data_ur) !== 0 ? pozostalo(item.data_ur) : null}
                    {pozostalo(item.data_ur) !== 0 ? (pozostalo(item.data_ur) !== 1 ? ' dni' : ' dzień') : null}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Home;
